import Vue from 'vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import SocialSharing from 'vue-social-sharing';
import VueSlider from 'vue-slider-component';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import VueLocalStorage from 'vue-localstorage';
import VueMeta from 'vue-meta';
import VueGtag from 'vue-gtag';
import router from './router';
import App from './App.vue';
import store from './store';
import i18n from './i18n';
import 'vue-slider-component/theme/default.css';

// VUE USE
[VeeValidate, VueMeta, VueScrollTo, SocialSharing, VueLocalStorage].forEach(x => Vue.use(x));
Vue.use(VueGtag, {
  config: { id: 'G-965ZVK0DRN' },
});
// VUE COMPONENTS
Vue.component('VueSlider', VueSlider);
Vue.config.productionTip = false;
axios.defaults.baseURL = process.env.VUE_APP_PUBLISHERS_API_URL;
Vue.prototype.$axios = axios;
// FILTERS
// RENAME VEHICLES
Vue.filter('filtersRename', (value) => {
  let result = value;
  if (!result) return '';
  if (result === 'makes') result = i18n.t('Marca');
  else if (result === 'models') result = i18n.t('Modelo');
  else if (result === 'bodyStyles') result = i18n.t('Estilo');
  else if (result === 'transmissions') result = i18n.t('Transmisión');
  else if (result === 'photos') result = i18n.t('Fotos');
  else if (result === 'conditions') result = i18n.t('Condición');
  else if (result === 'mileages') result = i18n.t('Millaje');
  return result;
});

Vue.filter('cleanPhone', value => parseInt(value.replace(/[^0-9]/g, ''), 10));
// NUMBER FORMAT
Vue.filter('numFormat', numFormat(numeral));
// HANDLE CONDITION FROM CONDITION ID TO STRING
Vue.filter('condition', (value) => {
  let result = value;
  if (!result) return '';
  if (result === 1) result = i18n.t('Nuevo');
  else if (result === 2) result = i18n.t('Usado');
  return result;
});

// Change default language based on domain
const domain = window.location.hostname;
i18n.locale = domain === 'ventaselite.com' ? 'es' : 'en';

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
